import {
  SequenceViewer,
  type SequenceViewerTab,
} from "@components/sequence-viewer";
import { createFileRoute, Navigate, useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";
import { useViewerFile } from "./-viewerFileContext";

export const Route = createFileRoute("/_data/view/$fileId/features")({
  component: FeaturesTab,
});

function FeaturesTab() {
  const file = useViewerFile();
  const navigate = useNavigate();

  const handleTabChange = useCallback(
    (tab: SequenceViewerTab) => {
      if (tab === "sequence") {
        navigate({ to: "/view/$fileId", params: { fileId: file.id } });
      } else if (tab === "primers") {
        navigate({ to: "/view/$fileId/primers", params: { fileId: file.id } });
      } else if (tab === "history") {
        navigate({ to: "/view/$fileId/history", params: { fileId: file.id } });
      } else if (tab === "searches") {
        navigate({
          to: "/view/$fileId/searches",
          params: { fileId: file.id },
        });
      }
    },
    [navigate, file.id],
  );

  if (file.type !== "GnomuxSequence") {
    return <Navigate to="/view/$fileId" params={{ fileId: file.id }} replace />;
  }

  return (
    <SequenceViewer
      sequenceId={file.content as string}
      tab="features"
      onTabChange={handleTabChange}
    />
  );
}
